import React, { useCallback, useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { clearGridFiltersTrue, refreshGridTrue, resetGridLayoutTrue, saveGridLayoutTrue } from "src/reducers/gridLayoutReducer";

const GridLayout = () => {
    const [isOpen, setIsOpen] = useState(false);
    const dispatch = useDispatch();
    const dropdownRef = useRef(null); // Reference for dropdown

    const saveLayout = useCallback(() => {
        dispatch(saveGridLayoutTrue());
    }, [dispatch]);

    const resetLayout = useCallback(() => {
        dispatch(resetGridLayoutTrue());
    }, [dispatch]);
    const clearFilters = useCallback(() => {
        dispatch(clearGridFiltersTrue());
    }, [dispatch]);
    const refresh = useCallback(() => {
        dispatch(refreshGridTrue());
    }, [dispatch]);
    const menuItems = [
        { label: "Save Layout", onClick: saveLayout, iconClass: "icon-save" },
        { label: "Reset Layout", onClick: resetLayout, iconClass: "icon-reset" },
        { label: "Clear Filters", onClick: clearFilters, iconClass: "icon-clearfilter" },
        { label: "Refresh", onClick: refresh, iconClass: "icon-refresh" },
    ];

    const handleOnClick = useCallback((item) => () => {
        setIsOpen(false);
        item.onClick();
    }, []);

    // Close dropdown when clicking outside
    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        }

        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div style={{ position: "relative", display: "inline-block" }} ref={dropdownRef}>
            {/* Three Dots Button */}
            <button
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    background: "none",
                    border: "none",
                }}
            >
                <span className="icon vertical-dots cursor-pointer"></span>
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="p-3.5 absolute top-[100%] right-0 dark:!bg-menubghover bg-textWhite border border-inputBorder shadow-md rounded-5 min-w-48 z-30">
                    <ul className="!m-0" style={{ listStyle: "none" }}>
                        {menuItems.map((item) => (
                            <li
                                key={item?.label}
                                className={`cursor-pointer p-2 items-center space-x-1.5 dark:hover:bg-profileHoverColor hover:bg-menubghover rounded-5
                                    }`}
                                onClick={handleOnClick(item)}
                            >
                                <span className={`icon cursor-pointer ${item.iconClass}`}></span><span className="text-subTextColor font-medium text-base"> {item.label}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

export default GridLayout;
